import React, { useState, useEffect } from 'react';

import {useTranslation} from "react-i18next";

import PropTypes from 'prop-types';
import validate from "validate.js";

import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Alert from "@material-ui/lab/Alert";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputAdornment from "@material-ui/core/InputAdornment";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import '../../assets/scss/onboarding-step1.css'
import useGaTracker from '../../common/components/ga/useGaTracker'
import useGa4Tracker from '../../common/components/ga/useGa4Tracker'
import {useSelector} from "react-redux";

const constraints = (t) => ({
  tenant: {
    presence: { allowEmpty: false, message: t('commons.validation.field.required')},
    length: {
      minimum: 3, maximum: 50, message: t("onboardingStep2.form.company.invalidateLength")
    },
    format: {
          pattern: "^[a-z0-9][a-z0-9\\_\\-\\.]{2,49}$",
          message: t("onboardingStep2.form.company.invalidateTenantNameError"),
    },
  },
  industry: {
    presence: { selected: false, message: t("commons.validation.field.required'") },
  },
  useProfile: {
    presence: { selected: false, message: t("commons.validation.field.required'") },
  },
  country: {
    presence: { selected: false, message: t("commons.validation.field.required'") },
  },
  timezone: {
    presence: { selected: false, message: t("commons.validation.field.required'") },
  },
  lang: {
    presence: { selected: false, message: t("commons.validation.field.required'") },
  },
  role: {
    presence: { selected: false, message: t("commons.validation.field.required'") },
  },
});

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column'
  },
  field: {
    margin: '10px 0',
  },
  paper: {
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  paper2: {
        marginTop: '10px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fffffff2',
        width:'60%',
        padding: '0 5% 0 5%',
        borderRadius: '20px',
        minWidth: '310px',
        maxWidth: '570px'
  },
  avatar: {
    margin: '1px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    maxWidth: '500px',
    minWidth: '280px'
  },
  submit: {
    display: 'flex',
    margin: '20px 0px 20px 0px',
    width: '200px',
    background: '#a5166c'
  },
  headerContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      textAlign: "center",
      marginTop: "18px"
    },
    logo: {
      height: "60px"
  },
  info: {
    marginTop: "20px",
    fontSize: "15px"
  },
  error: {
    color: "red"
  },
  rowContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginTop: '8px'
  },
  blockElem: {
    display: "flex",
    width: "50%",
  },
  selectPlaceholder: {
      color: "#b5acac",
  },
}));

export const OnboardingStep2 = (
    {dataStep1, countries, industries, profiles, validateUrlName, timezones, languages, update, validateTenantName, listTimezone,roles}) => {

  const classes = useStyles();
  const language = useSelector((state) => state.app.language);
  const [t, i18n] = useTranslation('common');

  const schema = constraints(t);

  const [helperUrlName, setHelperUrlName] = useState('');

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
        tenant: dataStep1 && dataStep1.tenantLabel ? dataStep1.tenantLabel.trim().toLowerCase().replace(/\s/g, '') : ''
    },
    validateUrlNameFirstResponse: dataStep1 && dataStep1.isTenantUrlUsed ? dataStep1.isTenantUrlUsed : false,
    touched: {},
    errors: {},
    appSumoAccount: dataStep1.appSumoAccount
  });

  useEffect(() => {
   if( validateUrlName ){
      setHelperUrlName(t("onboardingStep2.form.company.validateTenantNameError"));
   } else {
     setHelperUrlName('');
   }
   setFormState(formState => ({
    ...formState,
    isValid: (!validateUrlName) && haveValueFields(),
   }));
  }, [validateUrlName, t])

  useEffect(() => {
    handleValidateTenantName();
    const errors = validate(formState.values, schema, { fullMessages: false });
    setFormState(formState => ({
      ...formState,
       isValid: !errors && (!validateUrlName),
       errors: errors || {}
    }));
  }, [formState.values]);

    useEffect(() => {
     i18n.changeLanguage(language);
    }, [language, i18n]);

  useEffect(function () {
      const { values } = formState;
      if (values.industry && values.industry !== '') {
          setValueByUpdateLang('industry', undefined);
      }
      if (values.useProfile && values.useProfile !== '') {
          setValueByUpdateLang('useProfile', undefined);
      }
      if (values.country && values.country !== '') {
          setValueByUpdateLang('country', undefined);
      }
      if (values.timezone && values.timezone !== '') {
          setValueByUpdateLang('timezone', undefined);
      }
      if (values.lang && values.lang !== '') {
          setValueByUpdateLang('lang', undefined);
      }
  }, [i18n.language]);

  const handleChange = event => {
    event.persist();
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));

    if (event.target && event.target.name && event.target.name  === 'country') {
        const countryCode = event.target.value
        setValueByUpdateLang('timezone', undefined);
        listTimezone(countryCode)
     }
  };

  const hasError = field =>
      !!(formState.touched[field] && formState.errors[field]);

  const handleValidateTenantName = () => {
    const { values } = formState;
      if (values.tenant &&  values.tenant.length > 3 ) {
           validateTenantName(values.tenant);
      }
  }

 const setValueByUpdateLang = (field, value) =>{
   setFormState(formState => ({
            ...formState,
            values: {
                ...formState.values,
                [field]: value
            },
            touched: {
                ...formState.touched,
               [field]: false
   }
  }))
 }

  const handleOnsubmit = () => {
     const { values } = formState
     update("dataStep2", {
         tenantName: values.tenant,
         industry: values.industry,
         useProfile: values.useProfile,
         country: values.country,
         timezone: values.timezone,
         lang: values.lang,
         appSumoAccount: formState.appSumoAccount,
         userCharge: values.role,
     });
  }

  const haveValueFields = () => {
    const { values } = formState;
    return (values.industry && values.industry !== '') &&
           (values.useProfile && values.useProfile !== '') &&
           (values.country && values.country !== '') &&
           (values.timezone && values.timezone !== '') &&
           (values.lang && values.lang !== '');
  }

  useGaTracker('onboarding-step2-tenant-data');
  useGa4Tracker('onboarding-step2-tenant-data');

  
  return (
      <Container component="main" maxWidth="lg"  className="containerStep1">
          <Paper elevation={3} className={classes.paper2} >
              <div className={classes.paper}>
                  <Typography variant="h2" margin="normal" style={{fontWeight: '700', lineHeight: '40px'}}>
                      {t('onboardingStep2.title')}
                  </Typography>
                  <Typography variant="h3" margin="normal" style={{ marginTop: '20px', fontWeight: '700'}}>
                      {t('onboardingStep2.subtitle')}
                  </Typography>
                  <div >
                      <Alert severity="info" className={classes.info} >
                          <strong>{t('onboardingStep2.information')}</strong>
                          {dataStep1 && dataStep1.tenantLabel ? dataStep1.tenantLabel: ''}
                      </Alert>
                  </div>
                  <form className={classes.form}>
                      <div>
                          <TextField className={classes.textField} error={hasError('tenant')}  fullWidth
                                     helperText={ hasError('tenant') ? formState.errors.tenant[0] : null }
                                     margin="normal"
                                     label={t('onboardingStep2.form.company.label')}
                                     name="tenant"
                                     onChange={handleChange}
                                     type="text"
                                     value={formState.values.tenant || ''}
                                     InputProps={{
                                         startAdornment: <InputAdornment position="start">{window.location.origin + "/"}</InputAdornment>,
                                         maxlength: 30
                                     }}
                                     onBlur={ () => { handleValidateTenantName() } }
                                     variant="outlined"/>
                          <FormHelperText className={classes.error}>{helperUrlName}</FormHelperText>
                      </div>

                      <div className={classes.rowContainer}>
                          <FormControl className={classes.blockElem} >
                              <InputLabel id="select-helper-industry" className={classes.selectPlaceholder}>
                                  {t('onboardingStep2.form.industry.label')}
                              </InputLabel>
                              <Select
                                  labelId="simple-select-helper-industry"
                                  id="simple-select-helper-industry"
                                  name="industry"
                                  value={formState.values.industry || ''}
                                  onChange={handleChange}>
                                  {
                                    industries && industries.length && industries.length > 0 ?
                                    industries.map( (industry, index) => (
                                        <MenuItem key={index} value={industry.industryId}>
                                            {industry.label}
                                        </MenuItem>
                                    )) :  <MenuItem> No industry available </MenuItem>
                                  }
                              </Select>
                          </FormControl>

                          <FormControl className={classes.blockElem}  style={{ marginLeft: '30px'}}>
                              <InputLabel id="select-helper-use-profile"  className={classes.selectPlaceholder}>
                                  {t('onboardingStep2.form.useProfile.label')}
                              </InputLabel>
                              <Select
                                  labelId="simple-select-helper-use-profile"
                                  id="simple-select-helper-use-profile"
                                  name="useProfile"
                                  value={formState.values.useProfile || ''}
                                  onChange={handleChange}>
                                  {
                                    profiles && profiles.length && profiles.length > 0 ?
                                    profiles.map( (profile, index) => (
                                        <MenuItem key={index} value={profile.profileId}>
                                            {profile.label}
                                        </MenuItem>
                                    )) :  <MenuItem> No profile available </MenuItem>
                                  }
                              </Select>
                              <FormHelperText>{t('onboardingStep2.form.useProfile.helperText')}</FormHelperText>
                          </FormControl>
                      </div>

                      <div className={classes.rowContainer}>
                          <FormControl className={classes.blockElem} >
                              <InputLabel id="select-helper-country"  className={classes.selectPlaceholder}>
                                  {t('onboardingStep2.form.country.label')}
                              </InputLabel>
                              <Select
                                  labelId="simple-select-helper-country"
                                  id="simple-select-helper-country"
                                  name="country"
                                  value={formState.values.country || ''}
                                  onChange={handleChange}>
                                  {countries && countries.length && countries.length > 0 ?
                                      countries.map( (country, index) => (
                                          <MenuItem key={index} value={country.entity.code}>
                                              {country.name}
                                          </MenuItem>
                                      )) :  <MenuItem> No country available </MenuItem>
                                  }
                              </Select>
                          </FormControl>

                          <FormControl className={classes.blockElem} style={{ marginLeft: '30px'}}>
                              <InputLabel id="select-helper-timezone"  className={classes.selectPlaceholder}>
                                  {t('onboardingStep2.form.timezone.label')}
                              </InputLabel>
                              <Select
                                  labelId="simple-select-helper-timezone"
                                  id="simple-select-helper-timezone"
                                  name="timezone"
                                  value={formState.values.timezone || ''}
                                  onChange={handleChange}
                                  disabled={!formState.values.country}>
                                  {timezones && timezones.length && timezones.length > 0 ?
                                      timezones.map( (timezone, index) => (
                                          <MenuItem key={index} value={timezone.id}>
                                              {timezone.code}
                                          </MenuItem>
                                      )) :  <MenuItem> No timezone available </MenuItem>
                                  }
                              </Select>
                          </FormControl>
                      </div>
                      <FormHelperText>{t('onboardingStep2.form.timezone.helperText')}</FormHelperText>

                      <div className={classes.rowContainer}>
                          <FormControl className={classes.blockElem}>
                              <InputLabel id="demo-simple-select-helper-label"  className={classes.selectPlaceholder}>
                                  {t('onboardingStep2.form.language.label')}
                              </InputLabel>
                              <Select
                                  labelId="demo-simple-select-helper-label"
                                  id="demo-simple-select-helper"
                                  name="lang"
                                  value={formState.values.lang || ''}
                                  onChange={handleChange}>
                              	  {languages && languages.length && languages.length > 0 ?
                                      languages.map( (language, index) => (
                                          <MenuItem key={index} value={language.entity.id}>
                                              {language.name}
                                          </MenuItem>
                                      )) :  <MenuItem> No language available </MenuItem>
                                  }
                              </Select>
                          </FormControl>

                          <FormControl className={classes.blockElem} style={{ marginLeft: '30px'}}>
                              <InputLabel id="select-helper-role" className={classes.selectPlaceholder} >
                                {t('onboardingStep3.form.role.label')}
                              </InputLabel>
                              <Select
                                  labelId="simple-select-helper-role"
                                  id="simple-select-role"
                                  name="role"
                                  value={formState.values.role || ""}
                                  onChange={handleChange}>
                                  {roles && roles.length && roles.length > 0 ?
                                      roles.map( (role, index) => (
                                          <MenuItem key={index} value={role.jobRoleId}>
                                              {role.label}
                                          </MenuItem>
                                      )) :  <MenuItem> No role available </MenuItem>
                                  }
                              </Select>
                            </FormControl>
                    </div>         
                      <Button  className={classes.submit} color="primary"
                               disabled={!formState.isValid}
                               fullWidth
                               size="large"
                               variant="contained"
                               onClick={ () => handleOnsubmit() }>
                          {t('onboardingStep2.form.button')}
                      </Button>
                  </form>
              </div>
          </Paper>
      </Container>
  );
};

OnboardingStep2.propTypes = {
    history: PropTypes.object,
    validateTenantName: PropTypes.func,
    listCountries: PropTypes.func,
    listTimezone: PropTypes.func,
    listLanguages: PropTypes.func,
    listIndustries: PropTypes.func,
    listProfiles: PropTypes.func,

    validateUrlName: PropTypes.object,
    countries: PropTypes.object,
    industries: PropTypes.object,
    profiles: PropTypes.object,
    timezones: PropTypes.object,
    languages: PropTypes.object
};
